/**
 * TypingIndicator Component
 *
 * Shows real-time typing status for live feel.
 */
import React from "react";

export function TypingIndicator({ isTyping, partnerName = "Partner" }) {
  if (!isTyping) return null;

  return (
    <div className="flex items-center gap-2 text-sm text-content-secondary py-2">
      <div className="flex gap-1">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="w-2 h-2 bg-content-tertiary rounded-full animate-bounce"
            style={{ animationDelay: `${i * 100}ms` }}
          />
        ))}
      </div>
      <span>{partnerName} is typing...</span>
    </div>
  );
}
